export const truncate = (input: string, characterLimit: number) =>
  input ? (input.length > characterLimit ? `${input.substring(0, characterLimit)}...` : input) : ""; //Google has a 160 character limit for snippet, 55 for title

// https://teamtreehouse.com/community/difference-between-15-and-15em-in-terms-of-lineheight
export const adjustLineHeight = (value: string | null | undefined): string | undefined =>
  value ? value.replace("em", "") : value ?? undefined;
